/**
 * Scroll reveal + lazysizes-compat for water dispenser metafield HTML.
 * Old metafield markup uses class="lazyload" + data-src (no src). Horizon no longer
 * ships lazysizes globally, so we hydrate those images on connect.
 */
if (!customElements.get('water-dispenser-right-image')) {
  class WaterDispenserRightImage extends HTMLElement {
    /** @type {IntersectionObserver | null} */
    _observer = null;

    connectedCallback() {
      this._hydrateLazyImages();

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this._observer?.unobserve(entry.target);
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -10% 0px',
        }
      );

      this._observeTargets();
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _hydrateLazyImages() {
      this.querySelectorAll('img.lazyload[data-src], img[data-src]').forEach((img) => {
        const src = img.getAttribute('data-src');
        if (src && !img.getAttribute('src')) {
          img.setAttribute('src', src);
        }

        const srcset = img.getAttribute('data-srcset');
        if (srcset && !img.getAttribute('srcset')) {
          img.setAttribute('srcset', srcset);
        }

        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');

        if (!img.getAttribute('loading')) {
          img.setAttribute('loading', 'lazy');
        }
      });
    }

    _observeTargets() {
      const observer = this._observer;
      if (!observer) return;

      const targets = this.querySelectorAll(
        '.left_text .title, .left_text .subtitle, .water_dispenser_image .title_box'
      );
      targets.forEach((el) => observer.observe(el));
    }
  }

  customElements.define('water-dispenser-right-image', WaterDispenserRightImage);
}
